export enum FollowUpContextEnum {
  canceleds = 'CANCELED',
  capitalizations = 'CAPITALIZATION',
  policies = 'HIRED_DATA',
  estates = 'ESTATES',
  analysis = 'BOND_INSURANCES',
}
